export const FORM_ID = "subscriptionForm";

export const RECAPTCHA_ACTION = "SUBMIT_CONTACT_FORM";

export const EMAIL_SUBSCRIPTION_API_PATH = "/api/email-subscription";

export const NEWSLETTER_CONTAINER_NAME = "newsletter";
export const NEWSLETTER_WIDE_CONTAINER_QUERY = `@container ${NEWSLETTER_CONTAINER_NAME} (min-width: 48rem)`;
export const NEWSLETTER_MODAL_SELECTOR = '[data-newsletter-variant="modal"] &';

export const BLOOMREACH_LEAD_CAPTURE_EVENT = "ecco:lead-capture-eligible";
export const BLOOMREACH_LEAD_CAPTURE_SESSION_KEY = "bloomreach_lead_capture_shown";
